// extracted by mini-css-extract-plugin
export default {"logo":"_2sFSXnlRBSfL4hMzkw-Rb5","headerUtilityActivateFadeIn":"xcIDhHfrlJq_ViZKqNFt-","slideUtilityAnimation":"_3ePrzS7f2KQZ8r5xwaavZY"};